/*
  Cart summary pin guard.
  Some app-driven add-to-cart flows (e.g. bundle apps) open or re-render the
  cart drawer in an order that breaks the height chain, leaving the summary
  and checkout button below the fold on first open. This watches every drawer
  open / cart update, and if the checkout button isn't visible it re-asserts
  the layout chain inline and, as a last resort, scrolls the summary into view.
*/
(function () {
  'use strict';

  function repair() {
    var cd = document.querySelector('cart-drawer-component');
    if (!cd) return;
    var dlg = cd.querySelector('dialog');
    if (!dlg || !dlg.open) return;
    var btn = cd.querySelector('.cart__checkout-button');
    var sm = cd.querySelector('.cart-drawer__summary');
    if (!btn || !sm) return;

    // The theme decides pinned vs scrolling summary only when the drawer opens.
    // A first add-to-cart opens the drawer before the summary exists, so it
    // picks "scrolling" even on tall screens. Re-decide with the real sizes:
    // only a summary taller than half the drawer (e.g. phones in landscape)
    // scrolls, since pinning it there would cover every product.
    var dh = dlg.getBoundingClientRect().height;
    if (dh > 0 && sm.getBoundingClientRect().height / dh > 0.5) {
      dlg.setAttribute('cart-summary-sticky', 'false');
      sm.style.removeProperty('position');
      sm.style.removeProperty('bottom');
      return;
    }
    dlg.setAttribute('cart-summary-sticky', 'true');

    var r = btn.getBoundingClientRect();
    var broken = r.height === 0 || r.bottom > window.innerHeight + 2;
    if (!broken) return;

    var cic = cd.querySelector('cart-items-component');
    var content = cd.querySelector('.cart-drawer__content');
    if (cic) {
      cic.style.display = 'flex';
      cic.style.flexDirection = 'column';
      cic.style.height = '100%';
      cic.style.minHeight = '0';
    }
    if (content) {
      content.style.flex = '1 1 auto';
      content.style.minHeight = '0';
      content.style.height = 'auto';
      content.style.overflowY = 'auto';
    }
    sm.style.position = 'sticky';
    sm.style.bottom = '0';

    requestAnimationFrame(function () {
      var r2 = btn.getBoundingClientRect();
      if (r2.bottom > window.innerHeight + 2 || r2.height === 0) {
        sm.scrollIntoView({ block: 'end' });
      }
    });
  }

  function schedule() {
    setTimeout(repair, 60);
    setTimeout(repair, 350);
    setTimeout(repair, 900);
  }

  // re-renders can add the summary after the drawer opened (slow cart
  // refreshes): check again once the drawer's DOM settles
  var settleTimer = null;
  function repairWhenSettled() {
    clearTimeout(settleTimer);
    settleTimer = setTimeout(repair, 120);
  }

  // theme paths
  document.addEventListener('dialog:open', schedule, true);
  document.addEventListener('cart:update', schedule, true);

  // app paths that call showModal() directly: watch the dialog's open attribute
  var armedDialog = null;
  function arm() {
    var dlg = document.querySelector('cart-drawer-component dialog');
    if (!dlg || dlg === armedDialog) return;
    armedDialog = dlg;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'open' && dlg.open) {
          schedule();
          break;
        }
      }
    }).observe(dlg, { attributes: true });
    new MutationObserver(repairWhenSettled).observe(dlg, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') arm();
  else document.addEventListener('DOMContentLoaded', arm);
  // re-arm if a morph replaced the dialog node
  document.addEventListener('cart:update', function () { setTimeout(arm, 500); }, true);
})();
